@let hasShiftAttachmentsReadPermission =
  can(RoleAction.Read, RolePermissionSubject.ShiftAttachment);
@let approvedTimeReportAttachmentsFeatureFlag =
  'approved-time-report-attachments' | featureFlagPure | async;
@if (
  {
    shifts: shifts$ | async,
    isDrawerVisible: isDrawerVisible$ | async,
    isLoading: isLoading$ | async,
  };
  as data
) {
  @if (data.isDrawerVisible) {
    <nz-drawer
      [nzVisible]="true"
      [nzMask]="false"
      nzPlacement="right"
      [nzTitle]="'page.shift_timeline.drawer.shift_form' | translate"
      [nzClosable]="false"
      (nzOnClose)="closeDrawer()"
    >
      <ng-container *nzDrawerContent>
        @if (data.shifts) {
          <div class="mb-2">
            <wilson-release-multi-select-shift-button
              [selectedShifts]="data.shifts"
              [isOperationOnGoing]="
                isOperationOnGoingSignal() || !!data.isLoading
              "
              (releaseShiftOperationOngoing)="
                isOperationOnGoingSignal.set($event)
              "
              (releaseShiftsSuccess)="
                multipleShiftsDrawerService.refreshDrawerData()
              "
            ></wilson-release-multi-select-shift-button>
          </div>
          <div class="mb-2">
            <wilson-assign-multi-select-shifts-button
              [selectedShifts]="data.shifts"
              [isOperationOnGoing]="
                isOperationOnGoingSignal() || !!data.isLoading
              "
              (triggerAssignMultiShifts)="
                assignShiftOperationTriggered.emit(data.shifts)
              "
            ></wilson-assign-multi-select-shifts-button>
          </div>
          <div class="mb-2">
            <wilson-move-multi-select-shifts-button
              [selectedShifts]="data.shifts"
              [isOperationOnGoing]="
                isOperationOnGoingSignal() || !!data.isLoading
              "
              [hasServiceActivity]="hasServiceActivitySignal()"
              [hasWilsonShareActivity]="hasWilsonShareActivitySignal()"
              (moveShiftOperationTriggered)="
                moveShiftOperationTriggered.emit(data.shifts)
              "
            ></wilson-move-multi-select-shifts-button>
          </div>
          <div class="mb-2">
            <wilson-unassign-multi-select-shifts-button
              [selectedShifts]="data.shifts"
              [isOperationOnGoing]="
                isOperationOnGoingSignal() || !!data.isLoading
              "
              (unassignShiftsOperationTriggered)="
                unassignShiftsOperationTriggered.emit(data.shifts)
              "
            ></wilson-unassign-multi-select-shifts-button>
          </div>
          <div class="mb-2">
            <wilson-delete-multi-select-shifts-button
              [selectedShifts]="data.shifts"
              [isOperationOnGoing]="
                isOperationOnGoingSignal() || !!data.isLoading
              "
              [hasServiceActivity]="hasServiceActivitySignal()"
              (deleteOperationTriggered)="
                deleteOperationTriggered.emit(data.shifts)
              "
            ></wilson-delete-multi-select-shifts-button>
          </div>
          @if (hasShiftAttachmentsReadPermission) {
            <div class="mb-2">
              <wilson-add-attachments-multi-select-shifts-button
                [selectedShifts]="data.shifts"
                [isOperationOnGoing]="
                  isOperationOnGoingSignal() || !!data.isLoading
                "
                (addOperationTriggered)="isOperationOnGoingSignal.set($event)"
              ></wilson-add-attachments-multi-select-shifts-button>
            </div>
            @if (approvedTimeReportAttachmentsFeatureFlag) {
              <div class="mb-2">
                <wilson-add-shift-report-attachments-multi-select-shifts-button
                  [selectedShifts]="data.shifts"
                  [isOperationOnGoing]="
                    isOperationOnGoingSignal() || !!data.isLoading
                  "
                  (addOperationTriggered)="isOperationOnGoingSignal.set($event)"
                ></wilson-add-shift-report-attachments-multi-select-shifts-button>
              </div>
            }
          }
        }
        <button
          nz-button
          nzType="default"
          (click)="closeDrawer()"
          class="w-100 fw-normal"
          [disabled]="isOperationOnGoingSignal() || data.isLoading"
        >
          {{ 'action.unselect_all' | translate }}
        </button>
        @if (data.isLoading) {
          <nz-skeleton
            class="mt-4"
            [nzActive]="true"
            [nzParagraph]="{ rows: 6 }"
          ></nz-skeleton>
        } @else {
          <h6 class="mt-3">
            {{
              'page.shift_timeline.drawer.selected_shifts'
                | translate: { count: data.shifts?.length || 0 }
            }}
          </h6>
          <div class="selected-shift-list">
            <nz-list nzSize="small">
              @for (shift of data.shifts; track shift) {
                <nz-list-item>
                  <nz-list-item-meta>
                    <nz-list-item-meta-title>
                      <a
                        class="name"
                        [routerLink]="['/shifts', shift.id]"
                        target="_blank"
                      >
                        @if (shift) {
                          {{ shift.name }} ({{
                            shift.startDate | date: DateTimeFormat.DayAndMonth
                          }})
                        } @else {
                          unknown
                        }
                      </a>
                    </nz-list-item-meta-title>
                  </nz-list-item-meta>
                  <ul nz-list-item-actions class="action-area">
                    <nz-list-item-action>
                      <fa-icon
                        class="action"
                        (click)="unselect(shift.id)"
                        [icon]="faTrashAlt"
                      ></fa-icon>
                    </nz-list-item-action>
                  </ul>
                </nz-list-item>
              }
            </nz-list>
          </div>
        }
      </ng-container>
    </nz-drawer>
  }
}
